import * as React from "react";
import { twMerge } from "tailwind-merge";

export interface FormActionsProps extends React.HTMLAttributes<HTMLDivElement> {
  align?: "start" | "end" | "between";
}

export function FormActions({ align = "end", className, ...rest }: FormActionsProps) {
  const justify = align === "start" ? "justify-start" : align === "between" ? "justify-between" : "justify-end";
  return <div {...rest} className={twMerge("flex gap-2", justify, className)} />;
}
